import { PrimitiveFieldDefinitionSchema } from './primitive';
import { DateFieldDefinitionSchema } from './date';
import { RichTextFieldDefinitionSchema } from './richtext';
import { AssetFieldDefinitionSchema } from './asset';
import { EnumFieldDefinitionSchema } from './enum';
import { ObjectFieldDefinitionSchema } from './object';
import { ArrayFieldDefinitionSchema } from './array';
export const FieldDefinitionSchema = PrimitiveFieldDefinitionSchema.or(AssetFieldDefinitionSchema)
    .or(DateFieldDefinitionSchema)
    .or(RichTextFieldDefinitionSchema)
    .or(ArrayFieldDefinitionSchema)
    .or(ObjectFieldDefinitionSchema)
    .or(EnumFieldDefinitionSchema);
//# sourceMappingURL=composite.js.map